module.exports = __webpack_public_path__ + "img/car-crossing.1e94fedb.jpg";